import request from '../utils/request';

// 发起演习
export const startSimulate = (data) => {
  return request.post('/device/simulate', data);
};

// 取消演习
export const cancelSimulate = (data) => {
  return request.post('/device/cancel-simulate', data);
};

// 获取演习记录列表
export const getSimulates = (params) => {
  return request.get('/simulates', { params });
};
